import { IdmClientContext } from "@sista/idm-client";
import { useContext, useEffect, useState } from "react";

import {
  providerUrn,
  REPRESENTATION_MANAGE_PERMISSION,
} from "../utils/representation";

/**
 * Smi spravovat zastupy zamestnancu poskytovatele: admin SISTA vzdy, jinak pravo u poskytovatele.
 * Zastupce jednajici za ciziho (treba spravce) nikdy - backend to stejne odmitne.
 */
export const useCanManageRepresentations = (providerId?: string | null) => {
  const { loggedAccount, resolveMyPermissions } = useContext(IdmClientContext);
  const represented = loggedAccount?.activeProfileRepresented === true;
  const admin = loggedAccount?.admin === true;
  const [permitted, setPermitted] = useState(false);

  useEffect(() => {
    setPermitted(false);
    if (represented || admin || providerId == null) return undefined;
    let active = true;
    resolveMyPermissions([providerUrn(providerId)]).then((permissions) => {
      if (active)
        setPermitted(permissions.includes(REPRESENTATION_MANAGE_PERMISSION));
    });
    return () => {
      active = false;
    };
  }, [represented, admin, providerId, resolveMyPermissions]);

  return !represented && (admin || permitted);
};
